export default {
    data() {
        return {
            loading: false,
            isDisabled: false, // Disables form when it's in preview mode
            isForApproval: false,
            recaptchaToken: '',
            validRecaptcha: true,
            signaturePadValid: true,
            isProcessed: false,
            isExpired: false,
        };
    },
    methods: {
        submit() {
            const { data, isEmpty } = this.$refs.signaturePad.$refs.signaturePad.saveSignature();
            this.$refs.signaturePad.$data.valid = !isEmpty;
            this.validRecaptcha = !!this.recaptchaToken;
            this.loading = true;
            if (this.$refs.form.validate() && !isEmpty && this.recaptchaToken) {
                const formData = _.clone(this.$store.state.secure_sign_forms[this.form]);
                formData['signature'] = data;
                const cleanFormData = this.clearFormData(formData);
                const requestData = {
                    form_type: this.formType,
                    data: cleanFormData,
                };
                axios
                    .post(route('api.v1.ssf.submit'), requestData)
                    .then(() => {
                        this.$root.$emit('show-confirmation-dialog');
                    })
                    .catch((error) => {
                        this.$root.notify(error, 'error.message', 'error');
                        this.loading = false;
                    });
            } else {
                this.loading = false;
            }
        },
        processRegistrationForms(process) {
            const urlSearchParams = new URLSearchParams(window.location.search);
            const uuid = urlSearchParams.get('preview');
            const hash = urlSearchParams.get('hash');
            const data = this.$store.state.secure_sign_forms[this.form];
            const approverData = _.clone(_.get(data, 'approverData', {}));
            const comment = _.get(approverData, 'comment');

            if (process === 'approve' || process === 'reject') {
                if (!this.$refs.approverSignaturePad || !this.$refs.approverSignaturePad.$refs.signaturePad) {
                    return;
                }

                const { data: signatureData, isEmpty } =
                    this.$refs.approverSignaturePad.$refs.signaturePad.saveSignature();
                this.$refs.approverSignaturePad.$data.valid = !isEmpty;
                if (isEmpty) {
                    return;
                }
                approverData.approverSignature = signatureData;
            }

            if (process === 'reject' && !comment) {
                this.isRejected = true;
                return;
            }
            axios
                .put(route('api.v1.ssf.' + process, { formSubmission: uuid }), {
                    hash: hash,
                    approverData: approverData,
                    data: this.clearFormData(data),
                })
                .then(() => {
                    this.$root.$emit('show-confirmation-dialog');
                })
                .catch((error) => {
                    this.$root.$emit('show-error-dialog', error.response.data.error);
                    this.loading = false;
                });
        },
        getFormData() {
            const urlSearchParams = new URLSearchParams(window.location.search);
            const uuid = urlSearchParams.get('preview');
            const hash = urlSearchParams.get('hash');

            if (uuid) {
                this.isDisabled = true;

                if (hash) {
                    this.isForApproval = true;
                }
                axios
                    .get(route('api.v1.ssf.preview', { formSubmission: uuid, hash }))
                    .then((response) => {
                        const responseApproverData = response.data.approver_data || response.data.approverData;
                        if (responseApproverData) {
                            response.data.data.approverData = responseApproverData;
                        }

                        this.isProcessed =
                            (responseApproverData && responseApproverData.comment) || response.data.is_approved
                                ? true
                                : false;
                        const expirationDays = (response.data.expiration_days || 14) * 24 * 60 * 60 * 1000;
                        const createdAt = new Date(response.data.created_at);
                        const expirationDate = new Date(createdAt.getTime() + expirationDays);
                        this.isExpired = new Date() > expirationDate;
                        Object.entries(response.data.data).forEach(([key, value]) =>
                            this.$store.dispatch('secure_sign_forms/updateProperty', {
                                value,
                                property: `${this.form}.${key}`,
                            })
                        );
                    })
                    .catch((error) => {
                        this.$root.$emit('show-error-dialog', error.response.data.error);
                    });
            }
        },
        clearFormData(obj) {
            return Object.fromEntries(
                Object.entries(obj).filter((entry) => entry[1] !== '' && entry[1] !== undefined && entry[1] !== null)
            );
        },
        onRecaptchaVerify(response) {
            this.recaptchaToken = response;
            this.validRecaptcha = true;
        },
        expired() {
            if (this.$refs.recaptcha) {
                this.$refs.recaptcha.reset();
            }

            if (this.$refs.recaptchaApprover) {
                this.$refs.recaptchaApprover.reset();
            }
            this.validRecaptcha = false;
        },
    },
};
